import type { BorderRadius } from '@dhl-ui/theme'
import { spacing } from '../../spacing'

export const borderRadius = (radius: BorderRadius = 2): string => (radius < 4 ? spacing((radius + 1) * 0.5) : '50%')
